import _AuthService from './AuthService';

// eslint-disable-next-line import/prefer-default-export
export const AuthService = _AuthService;
